<mat-form-field
  *ngIf="!displayOnlyMetaFunctionalities; else metaFunctionality"
  [ngClass]="{ autocomplete: appearance === 'outline' }"
  [ngStyle]="{ opacity: disabled ? '0.5' : '1' }"
  style="width: 100%"
  [appearance]="appearance"
>
  <mat-label>{{ label }}</mat-label>

  <input matInput style="display: none" [formControl]="textInput" />

  <ng-container *ngTemplateOutlet="metaFunctionality"></ng-container>

  <button matSuffix class="material-icons" mat-icon-button (click)="onClick()">
    <mat-icon>arrow_drop_down</mat-icon>
  </button>

  <mat-error *ngIf="textInput.hasError('required') && !hideError">
    {{ !!customError ? customError : label + ' is required' }}
  </mat-error>
</mat-form-field>

<ng-template #metaFunctionality let-formControl="formControl">
  <div (click)="onClick()">
    <input
      type="text"
      matInput
      [placeholder]="placeHolder"
      #autocompleteInput
      [matAutocomplete]="auto"
      [formControl]="textInput"
      [readonly]="!freeTextEnabled || disabled || readonly"
      [disabled]="disabled"
      [required]="required"
      (keyup)="onFreeTextInput(autocompleteInput.value)"
      (keyup.enter)="onFreeTextSelect(); optionPanelOpen()"
      (blur)="onFreeTextSelect(); optionPanelOpen()"
      autocomplete="disabled"
      (focus)="focusChanged(true, auto)"
      (blur)="focusChanged(false, auto)"
    />

    <mat-autocomplete
      autoActiveFirstOption
      #auto="matAutocomplete"
      [panelWidth]="panelWidth"
      class="single-autocomplete"
      (opened)="focusChanged(true, auto)"
      (closed)="focusChanged(false, auto)"
    >
      <span *ngIf="!disabled">
        <div
          class="input-container"
          style="display: flex; justify-content: space-between"
        >
          <input
            type="text"
            matInput
            [placeholder]="dropdownPlaceholder"
            #innerInput
            class="inner-input"
            [formControl]="filterInput"
            autocomplete="disabled"
          />

          <button
            *ngIf="filterInput.value"
            mat-icon-button
            (click)="filterClear(); optionPanelOpen()"
            matTooltip="Clear"
          >
            <mat-icon
              class="clear-icon"
              [ngStyle]="{ cursor: readonly ? 'default' : 'pointer' }"
            >
              clear
            </mat-icon>
          </button>
        </div>

        <div *ngIf="loaderText">
          <mat-option disabled>
            <span class="d-flex align-items-center justify-content-between">
              <span>{{ loaderText }}</span>
              <mat-spinner diameter="25"></mat-spinner>
            </span>
          </mat-option>
        </div>
        <div *ngIf="isFieldsLoading">
          <mat-option disabled>
            <div class="px-0 py-2 m-0 flex-container">
              <h3
                class="pb-2 skeleton-load-item field-name-skeleton-middle"
              ></h3>
            </div>
          </mat-option>
        </div>

        <div *ngIf="!loaderText && !isFieldsLoading">
          <mat-option
            class="mat-option-autocomplete"
            *ngIf="filteredOptionsArray && filteredOptionsArray.length === 0"
            disabled
            >{{ optionsEmpty }}</mat-option
          >
          <mat-option
            class="mat-option-autocomplete p-0"
            style="padding: 0;"
            *ngIf="
              multiSelect &&
              !hideTheAllOption &&
              filteredOptionsArray &&
              filteredOptionsArray.length !== 0
            "
          >
            <div 
              style="width: 100%; height: 100%; display: flex; align-items: center; padding: 0 16px; box-sizing: border-box;"
              (click)="$event.stopPropagation(); onSelectAll()"
            >
            <span *ngIf="multiSelect" matTooltip="All"> All </span>
            </div>
          </mat-option>
          <mat-option
            class="mat-option-autocomplete p-0"
            style="padding: 0;"
            *ngIf="
              multiSelect &&
              !optionItemDisabled &&
              !hideTheAllOption &&
              filteredOptionsArray &&
              filteredOptionsArray.length !== 0
            "
          >
            <div 
              style="width: 100%; height: 100%; display: flex; align-items: center; padding: 0 16px; box-sizing: border-box;"
              (click)="$event.stopPropagation(); onSelectAll()"
            >
            <span>
              <mat-checkbox
                [checked]="selectAll"
                disabled
                [class.mat-checkbox-disabled]="false"
              >
                All
              </mat-checkbox>
            </span>
            </div>
          </mat-option>

          <mat-option
            class="mat-option-autocomplete p-0"
            style="padding: 0;"
            *ngFor="let option of filteredOptions | async"
            [value]="option.value"
            [disabled]="option?.disabled && optionItemDisabled"
            (click)="!multiSelect ? onSelect(option) : null"
            [attr.data-testid]="'el_autocomplete_option_' + option.value"
          >
            <div 
              style="width: 100%; height: 100%; display: flex; align-items: center; padding: 0 16px; box-sizing: border-box;"
              (click)="multiSelect ? $event.stopPropagation() : null; multiSelect ? onSelect(option) : null"
            >
            <span
              *ngIf="!multiSelect"
              [matTooltip]="option.displayValue || option.value"
            >
              {{ option.displayValue ?? option.value }}
            </span>
            <span *ngIf="multiSelect" class="el-autocomplete-form-field">
              <mat-checkbox
                [checked]="option.selected"
                disabled
                [class.mat-checkbox-disabled]="false"
              >
                {{ option.displayValue ?? option.value }}
              </mat-checkbox>
            </span>
            </div>
          </mat-option>
        </div>
      </span>
    </mat-autocomplete>
  </div>
</ng-template>
